import React, { Component } from 'react'
import axios from 'axios';

require(`../assets/${process.env.PAGE}/css/components/camera.css`);
import backIcon from '../assets/common/renaper/dorso_seleccionado.png';

import DocumentCamera from './DocumentCamera';
import CustomSpinner from './CustomSpinner.js';

class RenaperAddBack extends Component {
  constructor(props){
    super(props);

    this.state = {
        file: null,
        loading: false,
        identityStatus: null,
    }

    this.handleChange = this.handleChange.bind(this);
    this.getNextStep = this.getNextStep.bind(this);
  }

  handleChange(file){

    this.setState({
      ...this.state,
      loading: true,
    });

    const ROOT_URL = process.env.API_URL;

    const config = {
        headers:
            {
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                'Content-Type': 'multipart/form-data'
            }
    };

    const formData = new FormData();

    formData.append('file', file);

    axios.post(`${ROOT_URL}/identity/renaper/add_back`, formData, config)
    .then((response)=> {
      let identityStatus = 'rejected';
      if(response.status >= 200 && response.status <= 300){
        if (response.data.status) {
          identityStatus = 'approved';
          setTimeout(this.props.onFinish, 5 * 1000);
        } else {
          setTimeout(this.props.onRollback, 5 * 1000);
        }
      }
      this.setState({
        ...this.state,
        loading: false,
        identityStatus: identityStatus,
      });
      //this.props.onFinish();
      /*Mostrar aprobado*/
    }).catch(error => {
      this.setState({
        ...this.state,
        loading: false,
        identityStatus: 'rejected',
      });
      setTimeout(this.props.onRollback, 5 * 1000);
    });;
  }

  getNextStep(){
    this.props.onFinish();
  }


  render() {
    const { loading, identityStatus } = this.state;

    const approvedMessage = (<p className={'success'}> Identidad Validada <span className="glyphicon glyphicon-ok" aria-hidden="true"></span></p>);

    const rejectedMessage = (<p className={'error'}> No pudimos leer los datos <span className="glyphicon glyphicon-remove" aria-hidden="true"></span></p>);

    return (
      <div style={{
        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        background: "#000",
      }} >
        <DocumentCamera
            headerTitle="Dorso"
            headerIcon={backIcon}
            onChange={this.handleChange}
            shapeStyle={{
                aspectRatio: 1,
                defaultFixedSide: 'height',
                borderRadius: '15px',
            }}/>
        {loading && (<CustomSpinner message={ 'Cargando documento...' }  />)}
        {identityStatus && (<CustomSpinner message={ identityStatus && ((identityStatus == 'rejected' && rejectedMessage) || (identityStatus === 'approved' && approvedMessage))}  />)}
      </div>)
  }
}
module.exports = RenaperAddBack;


/** WEBPACK FOOTER **
 ** ./src/components/RenaperAddBack.js
 **/